import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TickerService } from '../../../shared/services/ticker.service';
import { ApplyButtonComponent } from '../../../shared/components/apply-button/apply-button.component';

interface TickerItem {
  icon: string;
  name: string;
  symbol: string;
  price: number;
  change: number;
}

@Component({
  selector: 'app-hero-section',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule, ApplyButtonComponent],
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.scss']
})
export class HeroSectionComponent implements OnInit {
  tickerItems: any[] = [];
  displayedSymbols: string[] = ['ETHUSDT', 'USDTUSDT', 'XRPUSDT', 'SOLUSDT', 'BNBUSDT', 'DOGEUSDT', 'USDCUSDT', 'ADAUSDT', 'BTCUSDT', 'EURUSDT', 'TRXUSDT'];

  constructor(private tickerService: TickerService) {
    
  }

  ngOnInit() {
    this.loadTickers();
  }

  loadTickers() {
    this.tickerService.getAllTickers().subscribe((data) => {
      this.tickerItems = data.filter((item) =>
        this.displayedSymbols.includes(item.symbol)
      
      ).map((item) => ({
        icon: item.symbol.substring(0, 3).toLowerCase(), // Icon-Symbol extrahieren
        name: this.getCoinName(item.symbol),
        symbol: item.symbol,
        price: parseFloat(item.lastPrice).toFixed(2),
        change: parseFloat(item.priceChangePercent).toFixed(2)
      }));
    });

   

  }

  getCoinIcon(symbol: string): string {
    const icons: { [key: string]: string } = {
      'Ethereum': 'eth.svg',
      'USDT': 'usdt.png',
      'XRP': 'xrp.png',
      'Solana': 'sol.png',
      'BNB': 'bnb.png',
      'Dogecoin': 'doge.png',
      'USDC': 'usdc.png',
      'Cardano': 'ada.png',
      'BTC': 'btc.png',
      'Euro': 'eur.png',
      'Tron': 'trx.png'
    };
    return icons[symbol] || 'default.svg'; // Fallback auf ein Standard-Icon
  }

  getCoinName(symbol: string): string {
    const coinNames: { [key: string]: string } = {
      'ETHUSDT': 'Ethereum',
      'USDTUSDT': 'Tether',
      'XRPUSDT': 'XRP',
      'SOLUSDT': 'Solana',
      'BNBUSDT': 'BNB',
      'DOGEUSDT': 'Dogecoin',
      'USDCUSDT': 'USDC',
      'ADAUSDT': 'Cardano',
      'BTCUSDT': 'Bitcoin',
      'EURUSDT': 'Euro',
      'TRXUSDT': 'Tron'
    };
    
    return coinNames[symbol] || symbol;
  }

  openBewerbenLink() {
    window.open('https://go.horizonnet-consulting.at/analyse', '_blank');
  }

  // Method to handle the CTA button click
  onCtaClick(): void {
    // Implement the eligibility check or navigation logic here
    console.log('CTA clicked');
  }

  // Method to handle WhatsApp button click
  openWhatsApp(): void {
    const whatsappUrl = 'https://api.whatsapp.com/send/?phone=4367762852109&text=Hey%2C+Ich+h%C3%A4tte+gerne+mehr+Informationen+%2F+einen+ersten+Austausch+zum+Thema+%E2%80%9Emein+eigenes+Vertriebs-Business+aufbauen%22.&type=phone_number&app_absent=0';
    window.open(whatsappUrl, '_blank');
  }
} 